<template>
  <div class="w-100 container p-0">
    <div class="d-flex flex-column flex-lg-row justify-content-between button-holder">
      <!-- Essential X Information -->
      <div class="w-100 mr-lg-2">
        <button v-if="productSupplier" class="btn-info text-center" @click="openProductSupModal">
          <i class="material-icons vtd-icon-2 mr-3">info</i>
          <span>Essential
            {{ item.jsontype.charAt(0).toUpperCase() + item.jsontype.slice(1) }}
            Information</span>
        </button>
      </div>

      <!-- Voucher Button Types within TH Brick -->
      <div class="w-100 ml-lg-2">
        <!-- TF E-Voucher - takes priority over both supplierVoucher & normal (essenInfo voucher/default) vouchers -->
        <button v-if="hasValidVoucherNumber" class="voucher-btn" @click="openTFVoucher(item.vouchno)">
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i>
          <span class="th-main-head-btn">View Voucher</span>
        </button>

        <!-- Supplier Voucher -->
        <button v-else-if="hasSupplierVoucherFile" class="voucher-btn" @click="openSupplierVoucher">
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i>
          <span class="th-main-head-btn">View Voucher</span>
        </button>
        <!-- Additional Supplier Documents Modal - tweaked to look like a Voucher Modal -->
        <button v-else-if="hasAdditionalSupplierDocuments" class="voucher-btn" @click="openAdditionalDocumentsModal">
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i>
          <span class="th-main-head-btn">View Voucher</span>
        </button>
        <!-- Essential Information Voucher || General Fallback Voucher Modal (last in order to show if all above = falsy) -->
        <button v-else class="voucher-btn text-center position-relative" @click="openVoucherInformation">
          <i class="position-absolute text-center material-icons vtd-icon-2 mr-3">info</i>
          <span class="w-100 text-center">Voucher Information</span>
        </button>
      </div>
    </div>

    <!-- Action Required -->
    <div v-if="checkInSupplier" class="d-flex justify-content-center">
      <button class="btn-info text-center button-width" @click="openActionRequiredModal">
        <i class="material-icons vtd-icon-2 mr-3">info</i>
        <span>Action Required</span>
      </button>
    </div>

    <EssentialInfo ref="EssentialInfoRef" :item="item" />
    <VoucherModal ref="VoucherModalRef" title="Voucher Information" />
    <AdditionalDocuments ref="AdditionalDocumentsModalRef" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EssentialInfo from "@/partials/extra-info-buttons/essential-info";
import VoucherModal from "../modals/voucher-modal.vue";
import AdditionalDocuments from "@/modules/menu-bar/essential-info/additional-document";
import { openVoucher } from "../../../../../navigation/modals/vouchers-documents/service";

export default {
  components: {
    EssentialInfo,
    VoucherModal,
    AdditionalDocuments,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    itemtype: {
      type: String,
      default: null,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      productSupplier: false,
      voucherSupplier: false,
      checkInSupplier: false,
    };
  },
  mounted() {
    if (this.item.essentialInformation) {
      if (this.item.essentialInformation.checkInEssential.length > 0) {
        this.checkInSupplier = true;
      }

      if (this.item.essentialInformation.voucherEssential.length > 0) {
        this.voucherSupplier = true;
      }

      if (this.item.essentialInformation.productEssential.length > 0) {
        for (const element of this.item.essentialInformation.productEssential) {
          if (element.suppliers) {
            this.productSupplier = true;
          }
        }
      }
    }
  },
  computed: {
    mapData() {
      if (
        (this.itemtype === "accomodation" && this.item && this.item.geocode) ||
        (this.itemtype === "wedding" && this.item && this.item.geocode)
      ) {
        const coords = this.item.geocode.split(", ");
        return {
          lat: parseFloat(coords[0]),
          lng: parseFloat(coords[1]),
          zoom: 16,
        };
      }
      return null;
    },
    showEssential() {
      if (this.item.productEssential && this.item.productEssential.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      bookingNumber: "booking/getBookingNumber",
      essInfo: "booking/getEssentialInfo",
      sessionNum: "booking/getSessionID",
      bookingName: "booking/getBookingSurname",
      countryRef: "booking/getCountry",
      getAdditionalSupplierDocuments: "booking/getAdditionalSupDocs",
    }),
    getTravellers() {
      return this.serviceTravellers;
    },
    hasValidVoucherNumber() {
      return Boolean(this.item.vouchno && this.item.tourtype !== 'CRUISE')
    },
    supplierVoucherFilename() {
      const filenames = (this.essInfo.supplier_documents && this.essInfo.supplier_documents.filenames) || [];
      const supdocslist = this.item.supdocslist || [];
      // item.supdocslist holds indexes into supplier_documents.filenames - use it to find this item's voucher
      if (this.item.suppdoclink === 'true' && supdocslist.length && supdocslist[0] !== '') {
        return filenames[Number(supdocslist[0])] || '';
      }
      // No index to go on - only safe to assume the file is ours if it's the only one
      if (filenames.length === 1) {
        return filenames[0];
      }
      // A single additional supplier doc - open it directly rather than a modal with one file in it
      if (this.getAdditionalSupplierDocuments.length === 1) {
        return filenames[Number(this.getAdditionalSupplierDocuments[0])] || '';
      }
      return '';
    },
    hasSupplierVoucherFile() {
      return Boolean(this.supplierVoucherFilename)
    },
    hasAdditionalSupplierDocuments() {
      // Shown if supplierVoucherFilename = falsy and there are additional supplier documents for this item
      return this.getAdditionalSupplierDocuments.length > 0
    },
    getSupplierVoucherFile() {
      return this.supplierVoucherFilename.replace(/ /g, "%20");
    }
  },
  methods: {
    async openTFVoucher(vouchno) {
      const system = this.bookingNumber.charAt(0).toUpperCase() === 'R' ? 'IE' : 'UK';
      const vouch = await openVoucher(this.bookingName, this.bookingNumber, vouchno, system, this.sessionNum);
      this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });
      if (vouch.error) {
        this.showError('danger', 'Error loading PDF.')
      }
    },
    openSupplierVoucher() {
      const domain = this.countryRef === 'IE' ? 'ie' : 'com'
      window.open(
        `https://www.trailfinders.${domain}/tourdoc/bybookno/${this.bookingNumber}/${this.getSupplierVoucherFile}`,
        "_blank"
      );
    },
    openActionRequiredModal() {
      if (this.checkInSupplier) {
        this.$refs.EssentialInfoRef.showCheckInSup();
      }
    },
    openAdditionalDocumentsModal() {
      // Same payload as the non-TH bricks - title comes from item.operator e.g. "Trailfinders Japan"
      this.$refs.AdditionalDocumentsModalRef.showModal({
        partial: "AdditionalDocumentsModalRef",
        title: "Additional Documents",
        supplier: this.item.operator,
        docIndexes: this.getAdditionalSupplierDocuments,
        message: [this.essInfo.supplier_documents],
        flag: "additional",
      });
    },
    openProductSupModal() { //openProductSupModal
      if (this.productSupplier) {
        this.$refs.EssentialInfoRef.showProductSup();
      }
    },
    openVoucherInformation() {
      if (this.voucherSupplier) {
        // Opens Voucher Information Modal if it exists within Essential Information
        this.$refs.EssentialInfoRef.showVoucherSup();
      } else {
        // Opens Default Voucher Information Modal with generic text from TH Voucher Modal component
        this.$refs.VoucherModalRef.showModal();
      }
    },
  },
};
</script>

<style scoped>
.th-main-head-btn {
  text-align: center;
  width: 90%;
}

@media only screen and (max-width: 993px) {
  .th-main-head-btn {
    text-align: left;
    width: 100%;
  }
}
</style>
<style scoped>
@media (max-width: 934px) {
  .extra-info-alt button {
    margin-bottom: 0px !important;
  }
}
</style>
